export default __webpack_public_path__ + "static/24b430ee8499629da5aefc5328002529-17aa00ce7833664b0dca640685bde043.png";